module.exports = __webpack_public_path__ + "static/media/color-clear.cbb3b809.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/color-clear.svg
// module id = 2660
// module chunks = 7